import { useState, useEffect } from 'react';
import { getLocationFromIP } from '../modules/ip';
import {
  getOfflineSuppliers,
  getTransformOfflineSupplier,
} from '../modules/suppliers';

export const useBackfilledSuppliers = (
  onlineSuppliers,
  maxOfflineSuppliers,
  location,
  verticalName
) => {
  const [suppliers, setSuppliers] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const backfillSuppliers = async () => {
      // If there are already 6 or more suppliers, don't backfill
      if (
        !onlineSuppliers ||
        onlineSuppliers.results.length >= maxOfflineSuppliers ||
        !verticalName ||
        verticalName.toLowerCase() !== 'venues'
      ) {
        return;
      }

      setLoading(true);

      // Backfill only if there are less than 6 online suppliers
      const { lon, lat } = location || {};
      const { latitude, longitude } = location ? {} : await getLocationFromIP();

      const numberOfOfflineSuppliersToAdd =
        maxOfflineSuppliers - onlineSuppliers?.results?.length;

      const offlineSuppliers = await getOfflineSuppliers({
        lat: lat ?? latitude,
        lon: lon ?? longitude,
      });

      // Transform offline suppliers to match the shape of online suppliers
      const transformedOfflineSuppliers = offlineSuppliers
        .slice(0, numberOfOfflineSuppliersToAdd)
        .map(offlineSupplier => {
          return getTransformOfflineSupplier(offlineSupplier);
        });

      setSuppliers({
        ...onlineSuppliers,
        results: [...onlineSuppliers.results, ...transformedOfflineSuppliers],
        count:
          onlineSuppliers.results.length + transformedOfflineSuppliers.length,
      });

      setLoading(false);
    };

    backfillSuppliers();
  }, [onlineSuppliers, maxOfflineSuppliers, location, verticalName]);

  return [suppliers, loading];
};
